
export class OxylinkConstants {
    public static OXYLINK_AUTH_STORAGE_KEY = 'oxylink-storage';
    public static OXYLINK_FILTERS_STORAGE_KEY = 'oxylink-filters';

    //! COUNTRY > AREA > Group > SHOP
    public static MODEL_CODE_COUNTRY = 'COUNTRY';   //GROUP MODELS COUNTRY
    public static MODEL_CODE_AREAS = 'AREA';       //* AREAS
    public static MODEL_CODE_GROUP = 'Group';       //* SECTOR : Group pour Oxylink

    public static OFFERS_API_PERMISSIONS_NAME = 'OxylinkGoodDeals';
    public static OFFERS_API_ROOT = 'gooddeals';

}